<template>
  <v-layout row wrap style="padding: 9px 16px 10px 16px; margin-top: 1px;">
    <v-flex xs12 sm6 md4 lg4 xl4 v-for="(image, index) in images" :key="index">
      <v-img :src="image.signedUrl"
             :alt="image.fileName"
             aspect-ratio="1"
             max-height="200"
             @click="viewImage(image)"
             class="task-image grey lighten-4">
        <template v-slot:placeholder>
          <v-row
            class="fill-height ma-0"
            align="center"
            justify="center">
            <v-progress-circular indeterminate color="accent"></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CrewList',
  computed: {
    ...mapGetters({
      images: 'image/imagesByTask',
      task: 'workOrderTask/selectedTask'
    })
  },
  async created () {
    if (this.task != null) {
      await this.loadImagesByTask({ taskId: this.task.id, size: 'small' })
    }
  },
  methods: {
    ...mapActions({
      loadImagesByTask: 'image/loadImagesByTask',
      imageLink: 'image/getImageLink'
    }),
    async viewImage (image) {
      await this.imageLink(image.id)
    }
  }
}
</script>
<style scoped>
  .task-image:hover {
    cursor: pointer;
  }
</style>
